import useHehmApi from 'hooks/useHehmApi'

import { HehmDeviceHardware } from 'types/HehmDevice'

const useHehmDeviceHardware = (deviceId: string) => {
  const path = `/devices/${deviceId}/hardware`
  const {
    hehmData,
    isHehmDataLoaded: isHehmDeviceHardwareLoaded
  } = useHehmApi(path)

  const hehmDeviceHardware = hehmData as HehmDeviceHardware

  return {
    hehmDeviceHardware,
    isHehmDeviceHardwareLoaded
  }
}

export default useHehmDeviceHardware
